/* Carrito lateral Ada Hilo.
   - Intercepta cualquier formulario /cart/add y cualquier enlace o botón de carrito de la tienda.
   - Si algo falla (red, JS), deja que el navegador siga su camino normal hacia /cart. */
(function () {
  'use strict';
  var root = document.getElementById('ah-cart');
  if (!root || !window.fetch || !window.FormData) return;

  var panel = root.querySelector('.ah-cart-panel');
  var lines = root.querySelector('[data-ah-cart-lines]');
  var foot = root.querySelector('[data-ah-cart-foot]');
  var totalEl = root.querySelector('[data-ah-cart-total]');
  var discRow = root.querySelector('[data-ah-cart-disc]');
  var discVal = root.querySelector('[data-ah-cart-disc-v]');
  var nEl = root.querySelector('[data-ah-cart-n]');
  var errEl = root.querySelector('[data-ah-cart-err]');
  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  var lastFocus = null;
  var state = null;

  function money(cents) { return fmt.format((cents || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Error'); e.status = r.status; e.body = j; throw e; }
        return j;
      });
    });
  }

  function setCounts(n) {
    var sel = '[data-ah-count], .sj-count, .cart-bubble__text-count';
    document.querySelectorAll(sel).forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      if (el.classList.contains('sj-count') || el.hasAttribute('data-ah-count')) el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', !(n > 0)); });
    nEl.textContent = n > 0 ? '(' + n + ')' : '';
  }

  function render(cart) {
    state = cart;
    setCounts(cart.item_count);
    errEl.textContent = '';
    if (!cart.item_count) {
      lines.innerHTML = '<div class="ah-cart-empty"><p>Tu carrito está vacío.</p><a class="ah-cart-btn" href="/collections/all">Seguir comprando</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    lines.innerHTML = cart.items.map(function (it) {
      var variant = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { var n = o.name.toLowerCase(); var lab = (n === 'colour' || n === 'color') ? 'Color' : (n === 'size' || n === 'talla') ? 'Talla' : o.name; return lab + ': ' + o.value; }).join(' · ');
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<div class="ah-cart-line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="88" height="117" loading="lazy">' : '') + '</a>' +
        '<div><p class="ah-cart-name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
        (variant ? '<p class="ah-cart-var">' + esc(variant) + '</p>' : '') +
        '<p class="ah-cart-price">' + was + '<b>' + money(it.final_line_price) + '</b></p>' +
        '<div class="ah-cart-ctl"><div class="ah-qty">' +
        '<button type="button" data-act="minus" aria-label="Quitar una unidad"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
        '<span aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" data-act="plus" aria-label="Añadir una unidad">+</button></div>' +
        '<button type="button" class="ah-rm" data-act="remove">Quitar</button></div></div></div>';
    }).join('');
    var disc = cart.total_discount || 0;
    discRow.hidden = !(disc > 0);
    discVal.textContent = disc > 0 ? '−' + money(disc) : '';
    totalEl.textContent = money(cart.total_price);
  }

  function refresh() { return jsonFetch('/cart.js').then(render); }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('open'); panel.focus({ preventScroll: true }); });
    if (!state) { lines.innerHTML = '<div class="ah-cart-empty"><p>Cargando…</p></div>'; foot.hidden = true; refresh().catch(showErr); }
  }
  function close() {
    root.classList.remove('open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!root.classList.contains('open')) root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function showErr(e) {
    var m = (e && e.body && (e.body.description || e.body.message)) || 'No se ha podido actualizar el carrito. Inténtalo de nuevo.';
    errEl.textContent = m;
  }

  function change(key, qty, lineEl) {
    if (lineEl) lineEl.classList.add('is-busy');
    return jsonFetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(render).catch(function (e) { if (lineEl) lineEl.classList.remove('is-busy'); showErr(e); });
  }

  lines.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-act]'); if (!b) return;
    var line = b.closest('.ah-cart-line'); var key = line.dataset.key;
    var it = state && state.items.find(function (x) { return x.key === key; }); if (!it) return;
    var q = b.dataset.act === 'plus' ? it.quantity + 1 : b.dataset.act === 'minus' ? Math.max(1, it.quantity - 1) : 0;
    change(key, q, line);
  });
  root.querySelectorAll('[data-ah-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Añadir al carrito: cualquier formulario de la tienda que apunte a /cart/add */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || !/\/cart\/add(\.js)?(\?|$)/.test(new URL(form.action, location.href).pathname + '')) return;
    if (form.dataset.ahReady === '0') return; // la ficha aún no tiene talla elegida: su propio aviso se encarga
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Añadiendo…'; }
    var fd = new FormData(form);
    jsonFetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (err) {
        if (err && err.status) {
          var msg = form.querySelector('[data-ah-msg]');
          var t = (err.body && (err.body.description || err.body.message)) || 'No se ha podido añadir. Inténtalo de nuevo.';
          if (msg) msg.textContent = t; else { open(); showErr(err); }
        } else {
          HTMLFormElement.prototype.submit.call(form); // sin red o JS roto: envío normal → /cart
        }
      })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }, true);

  /* Abrir el carrito desde cualquier icono o enlace de carrito */
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target.closest('[data-ah-cart-open], [aria-controls="cart-drawer"], [data-testid="cart-drawer-trigger"], a[href]');
    if (!t) return;
    if (t.tagName === 'A' && !t.hasAttribute('data-ah-cart-open')) {
      var u; try { u = new URL(t.getAttribute('href'), location.href); } catch (x) { return; }
      if (u.origin !== location.origin || !/^\/cart\/?$/.test(u.pathname) || u.search) return;
    }
    if (location.pathname.replace(/\/$/, '') === '/cart') return; // en la página de carrito, que navegue normal
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  document.documentElement.classList.add('ah-cart-js');
  window.AHCart = { open: open, close: close, refresh: refresh };
  refresh().catch(function () {});
})();
